import { render } from "./AddMetricModal.vue?vue&type=template&id=64d6816f&scoped=true"
import script from "./AddMetricModal.vue?vue&type=script&lang=js"
export * from "./AddMetricModal.vue?vue&type=script&lang=js"

import "./AddMetricModal.vue?vue&type=style&index=0&id=64d6816f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d6816f"]])

export default __exports__